import classNames from "classnames"
import { ValueView } from "web/components"

function DummyRecordViewField({ field, divide = false }) {
  return (
    <>
      <div
        className={classNames(
          "flex h-[30px] items-center truncate pr-1.5 text-sm text-gray-500",
          { "border-t border-gray-50": divide }
        )}
      >
        <p className="truncate">{field.label}</p>
      </div>
      <div
        className={classNames(
          "flex h-[30px] min-w-4xs items-center justify-end truncate text-sm",
          {
            "border-t border-gray-50": divide,
          }
        )}
      >
        <ValueView
          fieldKey={field.key}
          value={field.dummy_value}
          has_more_info={false}
          inert
        />
      </div>
    </>
  )
}
export default function DummyRecordView({ fields, isDoubleColumn }) {
  return (
    <div
      className={classNames("grid gap-14", {
        "grid-cols-1": !isDoubleColumn,
        "grid-cols-2": isDoubleColumn,
      })}
    >
      <div>
        <div
          className="grid"
          style={{
            gridTemplateColumns: "fit-content(80%) 1fr",
          }}
        >
          {fields.slice(0, 10).map((field, i) => (
            <DummyRecordViewField
              key={field.key}
              field={field}
              divide={i > 0}
            />
          ))}
        </div>
      </div>

      {isDoubleColumn && (
        <div>
          <div
            className="grid"
            style={{
              gridTemplateColumns: "fit-content(80%) 1fr",
            }}
          >
            {fields.slice(10, 20).map((field, i) => (
              <DummyRecordViewField
                key={field.key}
                field={field}
                divide={i > 0}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
